import {language} from "./utils";
import {marked} from 'marked';

import condFr from "../assets/conditions/cond fr.md";
import condEn from "../assets/conditions/cond en.md";
import condDe from "../assets/conditions/cond de.md";
import condIt from "../assets/conditions/cond it.md";
import condEs from "../assets/conditions/cond es.md";

import assuFr from "../assets/cgu_assu/fr.md";
import assuEn from "../assets/cgu_assu/en.md";
import assuDe from "../assets/cgu_assu/de.md";
import assuIt from "../assets/cgu_assu/it.md";
import assuEs from "../assets/cgu_assu/es.md";

export function conditions(): string {
  const lang = language();
  const conds = {
    fr: condFr,
    en: condEn,
    de: condDe,
    it: condIt,
    es: condEs,
  }
  // We can assert type because we dont use async: true
  return <string>marked(conds[lang] || conds['fr']);
}
export function cgu_assus(): string {
  const lang = language();
  const assus = {
    fr: assuFr,
    en: assuEn,
    de: assuDe,
    it: assuIt,
    es: assuEs,
  }
  // We can assert type because we dont use async: true
  return <string>marked(assus[lang] || assus['fr']);
}
